module.exports = __webpack_public_path__ + "media/images/logo-fe5141d38a25f50068b4c69b77ca1ec8.svg";